import React from 'react';

/**
 * O selo do ambiente de homologação (22/10/2026).
 *
 * Duas abas abertas, uma de produção e outra de hml, são idênticas: lançar o
 * gasto de teste na aba errada é questão de tempo. O selo fica num canto, fixo,
 * em toda tela — inclusive nas públicas — e não ocupa espaço do layout nem
 * recebe clique.
 *
 * Aparece só com `REACT_APP_AMBIENTE=hml`, que a Vercel define no escopo
 * Preview. Produção não define, e não vê nada.
 */
export const EH_HML = process.env.REACT_APP_AMBIENTE === 'hml';

const SeloDoHml: React.FC = () => (
  <div
    aria-label="Ambiente de homologação"
    style={{
      position: 'fixed', left: 8, bottom: 8, zIndex: 2147483647,
      pointerEvents: 'none',
      background: 'var(--s-warn-deep)', color: '#fff',
      font: '700 11px/1 system-ui, sans-serif', letterSpacing: '0.08em',
      padding: '5px 8px', borderRadius: 6, opacity: 0.9,
    }}
  >
    HML
  </div>
);

export default SeloDoHml;
